import NotFoundPage from './page/NotFound'

const MainNotFound = () => {
    return <NotFoundPage />
}

export default MainNotFound
